module.exports = __webpack_public_path__ + "static/bg2-36ae5db45ac07cb80256eef0ce129a59.svg";